import React, { useState, useImperativeHandle, forwardRef } from "react";
import { createPortal } from "react-dom";
import orderImage from "../../assets/images/order-place.png";
import { useNavigate } from "react-router-dom";
import { printBillElectron } from "../../electron-utils/print-helper";
// import { printBill2 } from "../utils/print-helper";

const PlaceOrderModal = forwardRef((props, ref) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [order, setOrder] = useState({});
    const [products, setProducts] = useState([]);
    const navigate = useNavigate();
    const onCancel = () => {
        setModalVisible(false);
        setOrder({});
        setProducts([]);
    };

    const goHome = () => {
        setModalVisible(false);
        setOrder({});
        setProducts([]);
        // Replace navigation with a redirect (React Router or window.location)
        navigate("/pos/tables");
    };

    const handlePrint = async () => {
        console.log("order, products", order, products);
        printBillElectron(order, products);
        // await printBill2({
        //   ...order,
        //   items: [...products],
        // });
    };

    useImperativeHandle(ref, () => ({
        showDialog(order, products) {
            setModalVisible(true);
            setOrder(order ?? {});
            setProducts(products ?? []);
        },
    }));

    if (!modalVisible) return null;

    return createPortal(
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
            <div className="relative bg-white rounded-xl p-6 shadow-xl w-[500px] max-w-[90%]">
                {/* Close Button */}
                <button
                    className="absolute top-3 right-3 text-xl font-bold text-gray-600 hover:text-gray-900"
                    onClick={onCancel}
                >
                    ✕
                </button>

                {/* Image */}
                <div className="flex justify-center mb-5">
                    <img
                        src={orderImage}
                        alt="Order Placed"
                        className="w-24 h-24"
                    />
                </div>

                {/* Message */}
                <p className="text-center text-lg font-medium mb-6">
                    Are You Sure To Place Order?
                </p>

                {/* Buttons */}
                <div className="flex justify-center space-x-4">
                    <button
                        onClick={goHome}
                        className="px-5 py-2 bg-indigo-100 text-gray-900 rounded-md font-semibold hover:bg-indigo-200 transition"
                    >
                        Go Home
                    </button>
                    <button
                        onClick={handlePrint}
                        className="px-5 py-2 bg-red-500 text-white rounded-md font-semibold hover:bg-red-600 transition"
                    >
                        YES & PRINT
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
});

export default PlaceOrderModal;
